export const changeLoadingInProg = loadingInProgress => ({
  type: "CHANGE_LOADING",
  loadingInProgress
});
